import { render, staticRenderFns } from "./PartnerListComponent.vue?vue&type=template&id=a95439ec"
import script from "./PartnerListComponent.vue?vue&type=script&lang=js"
export * from "./PartnerListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports